import { useQuery } from '@tanstack/react-query';
import { fetchClinic } from '@/core/clinic/api';
import { useAuthz } from '@/core/authz/AuthzProvider';
import { qk } from '@/core/api/keys';

/**
 * The clinic's presentation settings WITH the read's state. ZOY-335: a
 * surface that quotes a clinic setting back to the user must be able to tell
 * "not loaded" from "loaded", so it never presents a fallback constant as the
 * clinic's configuration.
 */
export function useClinicSettingsState() {
  const authz = useAuthz();
  const query = useQuery({
    queryKey: authz.clinicId ? qk.clinic(authz.clinicId) : ['clinic', 'none'],
    queryFn: () => fetchClinic(),
    enabled: authz.clinicId !== null,
    staleTime: 10 * 60_000,
  });
  const settings = query.data?.settings ?? null;
  return {
    settings,
    /** The settings are genuinely unavailable — refused, failed, or not yet read. */
    unavailable: settings === null,
    isError: query.isError,
    refetch: query.refetch,
  };
}

/** The clinic's presentation settings (calendar/timezone/currency), cached. */
export function useClinicSettings() {
  return useClinicSettingsState().settings;
}
